import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { isPortalPathname } from '@/utils/portal';

export const useIsPortal = () => {
  const location = useLocation();
  const [isPortal, setIsPortal] = useState(() => isPortalPathname(location.pathname));

  useEffect(() => {
    const currentIsPortal = isPortalPathname(location.pathname);
    if (currentIsPortal !== isPortal) {
      setIsPortal(currentIsPortal);
    }
  }, [location.pathname, isPortal]);

  return isPortal;
};
